String.prototype.replaceAll = function(oldStr, newStr) { //将oldStr替换成newStr
  const reg = new RegExp(oldStr, 'g') //创建正则RegExp对象
  return this.replace(reg, newStr)
}
//订单模版信息
const orderTemplateList = [
  {
    name: '订单编号',//含义名（显示名称）
    dataKey: 'orderNo'//服务器返回字段
  },
  {
    name: '商品名称',//含义名（显示名称）
    dataKey: 'proName'//服务器返回字段
  },
  {
    name: '套餐名称',//含义名（显示名称）
    dataKey: 'optionName'//服务器返回字段
  },
  {
    name: '数量',//含义名（显示名称）
    dataKey: 'totalNum'//服务器返回字段
  },
  {
    name: '游客总人数',//含义名（显示名称）
    dataKey: 'totalNum'//服务器返回字段
  },
  {
    name: '出游日期',//含义名（显示名称）
    dataKey: 'travelDate'//服务器返回字段
  },
  {
    name: '商品ID',//含义名（显示名称）
    dataKey: 'proId'//服务器返回字段
  },
  {
    name: '订单金额',//含义名（显示名称）
    dataKey: 'orderAmount'//服务器返回字段
  },
  {
    name: '总费用',//含义名（显示名称）
    dataKey: 'orderAmount'//服务器返回字段
  },
  {
    name: '套餐关联行程',//含义名（显示名称）
    dataKey: 'routeDayPlan',//服务器返回字段
    isSpecial: true,//需要特殊处理
    getShowText(data) {
      return getRouteDayPlanTableText(data.routeDayPlan)
    }
  },
  {
    name: '联系人',//含义名（显示名称）
    dataKey: 'orderContacts',//服务器返回字段
    getShowText(data) {
      if (data) {
        return data.orderContacts + ',' + data.orderPhone
      }
      return '___'
    }
  },
  {
    name: '下单时间',//含义名（显示名称）
    dataKey: 'createDate'//服务器返回字段
  },
  {
    name: '出游人',//含义名（显示名称）
    dataKey: 'tourVOList',//服务器返回字段
    isSpecial: true,//需要特殊处理
    getShowText: list => getTravelerTabText(list)//需要特殊处理
  },
  {
    name: '成人单价',//含义名（显示名称）
    dataKey: 'adultPrice'//服务器返回字段
  },
  {
    name: '儿童单价',//含义名（显示名称）
    dataKey: 'childPrice'//服务器返回字段
  },
  {
    name: '房差单价',//含义名（显示名称）
    dataKey: 'roomDifferencePrice'//服务器返回字段
  },
  {
    name: '出发日期',//含义名（显示名称）
    dataKey: 'travelDate'//服务器返回字段
  },
  {
    name: '行程天数',//含义名（显示名称）
    dataKey: 'dayNum'//服务器返回字段
  },
  {
    name: '过夜天数',//含义名（显示名称）
    dataKey: 'nightNum'//服务器返回字段
  },
  {
    name: '线路名称',//含义名（显示名称）
    dataKey: 'proName'//服务器返回字段
  },
  {
    name: '行程描述',//含义名（显示名称）
    dataKey: 'optionName'//服务器返回字段
  },
  {
    name: '结束日期（回团日期）',//含义名（显示名称）
    dataKey: 'travelEndDate'//服务器返回字段
  }
]

function getRouteDayPlanTableText(list) {
  let text = ''
  if (list && list.length > 0) {
    list.forEach(item => {
      let dayText = item.dayNumber + '：' + item.dayPlanDeparture + '——' + item.dayPlanDestination + '\n'
      if (item.dayDanVo && item.dayDanVo.length > 0) {
        item.dayDanVo.forEach(dayItem => {
          if (dayItem.dayDanDes) {
            dayText = dayText + dayItem.dayDanDes.replace(/<[^<>]+>/g, '') + '\n'//提取富文本
          }
        })
      }
      dayText = dayText + `早餐:${item.dayPlanBreakfast} 午餐:${item.dayPlanLunch} 晚餐:${item.dayPlanDinner}` + '\n'
      dayText = dayText + `入住:${item.dayPlanHotel} ` + '\n'
      text = text + dayText + '\n\n'
    })
  }
  return text
}

function getTravelerTabText(list) {
  const headerStyle = `style="height: 30rpx;line-height: 30px;font-weight: 500;font-size: 18px;color: #444444";white-space: nowrap;`
  let travelerHeader = `<tr  ${headerStyle}>
    <th ${headerStyle}>中文姓名</th>
    <th  ${headerStyle}>证件类型</th>
    <th  ${headerStyle}>证件号</th>
    <th  ${headerStyle}>手机号</th>
    </tr>`
  let travelerContent = ''
  if (list && list.length > 0) {
    const lineStyle = `style="height: 24px;line-height: 24px; font-size: 14px;font-weight: 300;color: #444444;white-space: nowrap;"`
    list.forEach(item => {
      travelerContent = travelerContent + ` <tr ${lineStyle}>
           <td ${lineStyle}>${item.tourName}</td>
           <td ${lineStyle}>${item.cardTypeStr}</td>
           <td ${lineStyle}>${item.cardNo}</td>
           <td ${lineStyle}>${item.tourPhone}</td>
          </tr>`
    })
  }
  return `<table border="1" style="margin:0 auto;">${travelerHeader} ${travelerContent}</table>`
}

//合同模版辅助工具
export default class ContractTemplateHelper {

  //是不是特殊项
  static isSpecial(keyMean) {
    let findItem = orderTemplateList.find(item => keyMean === item.name)
    return findItem && findItem.isSpecial
  }

  /**
   * 替换订单信息
   * @param text 文本信息
   * @param replaceWords 替换的关键字
   * @param keyMean 关键字含义（后台返回）
   * @param data  订单详情数据
   * @returns {*|string}
   */
  static replaceOrderContent(text, replaceWords, keyMean, data) {
    let findItem = orderTemplateList.find(item => keyMean === item.name)
    if (findItem && findItem) {
      const content = findItem.getShowText ? findItem.getShowText(data) : (data[findItem.dataKey] ? data[findItem.dataKey] : '___')
      return text.replaceAll(`{{${replaceWords}}}`, content)
    }
  }

  /**
   * 根据字段含义获取字段的内容
   * @param data
   * @param keyMean
   */
  static getContent(data, keyMean) {
    let findItem = orderTemplateList.find(item => keyMean === item.name)
    if (findItem) {
      return data[findItem.dataKey]
    }
    return undefined
  }

  static getRouteDayPlanTableText(list) {
    return getRouteDayPlanTableText(list)
  }

  static getTravelerTabText(list) {
    return getTravelerTabText(list)
  }

  static checkCardContent(cardType, cardNo) {
    if (cardType && cardType == 1) {
      if (cardNo) {
        let cardInfo = ContractTemplateHelper.checkCardInfo(cardNo)
        return cardInfo.sex
      } else {
        return '男'
      }
    } else {
      return '男'
    }
  }

  static checkCardInfo(identityCard) {
    let len = (identityCard + '').length
    if (len == 0) {
      return 0
    } else {
      if ((len != 15) && (len != 18)) //身份证号码只能为15位或18位其它不合法
      {
        return 0
      }
    }
    let strBirthday = ''
    let sex = ''
    if (len == 18) {//处理18位的身份证号码从号码中得到生日和性别代码
      strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
      sex = identityCard.substring(16, 17)
    }
    if (len == 15) {
      strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
      sex = identityCard.substring(13, 14)
    }
    //时间字符串里,必须是“/”
    let birthDate = new Date(strBirthday)
    let nowDateTime = new Date()
    let age = nowDateTime.getFullYear() - birthDate.getFullYear()
    //再考虑月、天的因素;.getMonth()获取的是从0开始的,这里进行比较,不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
      age--
    }
    if (sex % 2 === 0) {
      sex = '女'
    } else {
      sex = '男'
    }
    return { age: age, sex: sex }
  }
}